export const buttonFocusStyles =
  'focus:ring-2 focus:ring-accent-500 focus:outline-none focus:ring-offset-2';

export const groupButtonFocusStyles =
  'group-focus:ring-2 group-focus:ring-accent-500 group-focus:outline-none' +
  ' group-focus:ring-offset-2';
